import React, { useEffect, useState } from 'react'
import { useRef } from 'react';
import {
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import axios from "../../../lib/axios";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useNavigate, useLocation } from 'react-router-dom';
import Paper from '@mui/material/Paper';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Typography } from '@mui/material';
import checkAndLock from "../../../GlobalFunction/checkAndLock";
import UnLock from "../../../GlobalFunction/UnLock";
import CrudButtons from '../../../GlobalFunction/CrudButtons';
// import { useModulePermissions } from '../../../GlobalFunction/useModulePermissions';
import ReportTable from '../../../atoms/ReportFolder/ReportTable';
import { useReactToPrint } from 'react-to-print';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

const CustomTextField = styled(TextField)(({ theme }) => ({
  '& .MuiFilledInput-root': {
    backgroundColor: 'transparent',
    border: '1px solid #e0e0e0',
    borderRadius: '4px',
  },
  '& .Mui-focused': {
    borderColor: '#673ab7',
  },
  '& .MuiFilledInput-root.Mui-focused': {
    border: '1px solid #673ab7',
  },
}));

const columns = [
  { id: 'RowNum', label: 'S.No.', minWidth: 170 },
  { id: 'CountryCode', label: 'Country Code', minWidth: 100 },
  { id: 'CountryName', label: 'CountryName', minWidth: 170 },
  { id: 'CountryAbrv', label: 'Short Name', minWidth: 100 }
];

const Country = () => {
  const [formData, setFormData] = useState({
    CountryName: '',
    CountryCode: '',
    ShortName: '',
    MobDigit: 0,
    PinDigit: 0
  });

  // const permissions = useModulePermissions("Country Master");

  const [error, setError] = useState({
    countryName: false,
    countryCode: false
  });

  const navigate = useNavigate();

  const [isEditMode, setIsEditMode] = useState(false);
  const [isFormDisabled, setIsFormDisabled] = useState(true);
  const [countryId, setCountryId] = useState(null);
  const location = useLocation();
  const [currentCountryId, setCurrentCountryId] = useState(null);
  const [isViewMode, setIsViewMode] = useState(false);
  const [mode, setMode] = useState('view');
  const [Status, setStatus] = useState("1");
  const [lastInsertedCountryId, setLastInsertedCountryId] = useState(null);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [selectedImage, setselectedImage] = useState("");
  const [UserLoginId, setUserLoginId] = useState(sessionStorage.getItem('UserId'));
  const [DataForPrint, setDataForPrint] = useState({});
  const [rows, setRows] = useState([]);
  const contentRef = useRef(null);
  const handlePrint = useReactToPrint({ contentRef });

  const countryNameRef = useRef(null);
  const countryCodeRef = useRef(null);
  const shortNameRef = useRef(null);
  const MobDigitRef = useRef(null);
  const PinDigitRef = useRef(null);

  useEffect(() => {
    if (location.state && location.state.CountryId) {
      setCurrentCountryId(location.state.CountryId);
      fetchCountryData(location.state.CountryId);
      setMode('view');
    } else {
      setMode('add');
      setIsFormDisabled(false);
    }
  }, [location]);

  useEffect(() => {
    const getRow = async () => {
      const params = {
        start: 1,
        PageSize: 1,
        SearchText: ""
      };
  
      try {
        const res = await axios.post('CountryMst/getAllCountryMasterDashBoard', { params });
  
        if (res.data && res.data.Data) {
          setRows(res.data.Data);
          setDataForPrint(res.data.Data);
        } else {
          console.error('No data found in response');
        }
      } catch (err) {
        console.error('Error fetching data:', err);
      }
    };
  
    getRow();
  }, []);

  const fetchCountryData = async (id, flag) => {
    try {
      const response = await axios.post('CountryMst/RetriveCountryMst', {
        CountryId: parseInt(id),
        Flag: flag
      });
      console.log("country-data", response);
      if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
        const countryData = response.data.Data[0];
        setFormData({
          CountryName: countryData.CountryName,
          CountryCode: countryData.CountryCode,
          ShortName: countryData.CountryAbrv,
          MobDigit: countryData.MobDigit ? countryData.MobDigit : 0,
          PinDigit: countryData.PinDigit ? countryData.PinDigit : 0

        });
        setselectedImage(countryData.CountryIcon);
        setStatus(countryData.Status.toString() || "0");
        setIsFormDisabled(true);
        setCurrentCountryId(countryData.CountryId);
      } else if (response.data.Status === 1 && response.data.responseStatusCode === 2) {
        toast.info(response.data.Message);

      } else {
        toast.error('Failed to fetch country data');
      }
    } catch (error) {
      console.error('Error fetching country data:', error);
      toast.error('Error fetching country data. Please try again.');
    }
  };

  const handlePrevious = async () => {
    if (currentCountryId && currentCountryId > 1) {
      await fetchCountryData(currentCountryId, "P");
    }
  };

  const handleNext = async () => {
    if (currentCountryId) {
      await fetchCountryData(currentCountryId, "N");
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));


    if (name === 'country') {
      setFormData(prevState => ({
        ...prevState,
        state: ''
      }));
    }

    if (name === 'country' && value !== '') {
      setTimeout(() => {
        shortNameRef.current.focus();
      }, 100000);
    }
  };

  const handleChangeStatus = (event) => {
    const updatedStatus = event.target.checked ? "1" : "0";
    setStatus(updatedStatus);
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      if (event.target === countryNameRef.current) {
        countryCodeRef.current.focus();
      } else if (event.target === countryCodeRef.current) {
        MobDigitRef.current.focus();
      }else if (event.target === MobDigitRef.current) {
        PinDigitRef.current.focus();
      }else if (event.target === PinDigitRef.current) {
        shortNameRef.current.focus();
      } else {
        shortNameRef.current.focus();
      }
    }
  };

  const handleSave = async () => {

    let hasError = false;

    if (!formData.CountryName) {
      toast.error('Country name is required');
      setError(prev => ({ ...prev, CountryName: true }));
      hasError = true;
    } else {
      setError(prev => ({ ...prev, CountryName: false }));
    }

    if (hasError) {
      return;
    }


    try {
      const payload = {
        CountryName: formData.CountryName,
        CountryCode: formData.CountryCode,
        CountryAbrv: formData.ShortName,
        CountryIcon: selectedImage,
        MobDigit: formData.MobDigit,
        PinDigit: formData.PinDigit,
        status: Status
      };

      let response;
      if (mode === 'edit') {
        payload.CountryId = currentCountryId;
        payload.UpdatedBy = parseInt(UserLoginId);
        response = await axios.patch('countryMst/UpdateCountryMaster', payload);
      } else {
        payload.CreatedBy = parseInt(UserLoginId);
        response = await axios.post('countryMst/InsertCountryMaster', payload);
      }

      if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
        toast.success(response.data.Message);
        if (mode === 'add') {
          setLastInsertedCountryId(response.data.Data)
          console.log(response.data.Data)
          await fetchCountryData(response.data.Data);
          setMode('view');
          setIsFormDisabled(true);
          setCurrentCountryId(response.data.Data);
        } else {
          setMode('view');
          await UnLock(currentCountryId, "MstCountry", "CountryId");
        }
        setIsFormDisabled(true);
      } else {
        toast.error(response.data.Message || 'Operation failed');
      }
    } catch (error) {
      console.error('Error saving/updating country:', error);
      toast.error('Error saving/updating country. Please try again.');
    }
  };

  const handleEdit = async () => {

    let Flag = await checkAndLock(currentCountryId, "MstCountry", "CountryId");
    console.log(Flag);
    switch (Flag) {
      case 0:
        setMode("edit");
        setIsFormDisabled(false);
        break;
      case 1:
        toast.info("Record  Already Locked", { autoClose: 500 });
        break;
      case 2:
        toast.info("Record Failed To Locked", { autoClose: 500 });
        break;
      default:
        toast.info("Something Went Wrong", { autoClose: 500 });
    }
  };

  const handleAdd = () => {
    setMode('add');
    setIsFormDisabled(false);
    setFormData({
      CountryName: '',
      CountryCode: '',
      ShortName: '',
      MobDigit: 0,
      PinDigit: 0
    });
    setselectedImage("");
    setCurrentCountryId(null);

    setTimeout(() => {
      countryNameRef.current.focus();
    }, 0);
  };

  const handleCancel = async () => {
    try {
      await fetchCountryData(1, "L");
      await UnLock(currentCountryId, "MstCountry", "CountryId");
      setMode('view');
      setIsFormDisabled(true);
    } catch (error) {
      toast.error('Error occurred while cancelling. Please try again.');
    }
  };

  const resetForm = () => {
    setFormData({
      CountryName: '',
      CountryCode: '',
      ShortName: '',
      MobDigit: 0,
      PinDigit: 0,
    });
    setCurrentCountryId(null);
    setMode('view');
  };

  const handleExit = () => {
    navigate('/masters/location')
  }

  const handleDeleteClick = () => {
    setOpenConfirmDialog(true);
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false);
  };

  const handleConfirmDelete = async () => {

    let Flag = await checkAndLock(currentCountryId, "MstCountry", "CountryId");
    console.log(Flag);
    switch (Flag) {
      case 0:
        setOpenConfirmDialog(false);
        await fetchCountryData(currentCountryId, "D");
        await fetchCountryData(currentCountryId, "N");
        setMode('view');
        setIsFormDisabled(true);
        break;
      case 1: toast.info("Record  Already Locked", { autoClose: 500 });
        break;
      case 2: toast.info("Record Failed To Locked", { autoClose: 500 });
        break;
      default: toast.info("Something Went Wrong", { autoClose: 500 });

    }

  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      const reader = new FileReader();

      const readFileAsBase64 = (file) => {
        return new Promise((resolve, reject) => {
          reader.onloadend = () => {
            resolve(reader.result);
          };
          reader.onerror = reject;
          reader.readAsDataURL(file);
        });
      };

      readFileAsBase64(file)
        .then(base64String => {
          console.log("base64String", base64String);
          setselectedImage(base64String);
        })
        .catch(err => {
          console.error('Error reading file:', err);
          toast.error('Error reading file. Please try again.');
        });
    }
  };

  return (
    <>

      <Box className="form-container" sx= {{ height: { xs:'700px', sm: '550px', lg: '550px', xl: '550px' } }}>

        <ToastContainer />
        <Grid container spacing={2} className='form_grid'>
          <Grid item xs={12} className='form_title' 
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              marginTop: '20px',
              flexDirection: { xs: 'column', sm: 'row', md: 'row' }
            }}
          >
            <Grid
              sx={{
                display: 'flex',
                justifyContent: { xs: 'center', sm: 'flex-start' },
                marginBottom: { xs: '10px', sm: 0 }
              }}
            >
              <Button
                variant="contained"
                size="small"
                className='three-d-button-previous'
                onClick={handlePrevious}
                sx={{ backgroundColor: '#635BFF', marginRight: { xs: '5px', sm: '10px' }, display: { xs: 'none', sm: 'block' } }}
                disabled={mode !== 'view' || !currentCountryId || currentCountryId === 1}
              >
                <KeyboardArrowLeftIcon />
              </Button>

              <Button
                variant="contained"
                size="small"
                // sx={{ margin: '0px 10px' }}
                className='three-d-button-next'
                onClick={handleNext}
                sx={{ backgroundColor: '#635BFF', display: { xs: 'none', sm: 'block' } }}
                disabled={mode !== 'view' || !currentCountryId }
              >
                <NavigateNextIcon />
              </Button>
            </Grid>

            <Typography
              variant="h5"
              sx={{
                margin: 'Auto',
                textAlign: { xs: 'center', sm: 'center' },
                fontSize: { xs: '24px', sm: '18px', md: '24px' }
              }}
            >
              Country Master
            </Typography>

            <Grid sx={{ display: "flex", justifyContent: "end" }}>
              <CrudButtons
                moduleName="Country Master"
                mode={mode}
                onAdd={handleAdd}
                onEdit={handleEdit}
                onView={handlePrint}
                onDelete={handleConfirmDelete}
                onExit={handleExit}
                readOnlyMode={isFormDisabled}
                onPrevious={handlePrevious} 
                onNext={handleNext} 
              />
            </Grid>
          </Grid>

          <Grid item xs={12} className='form_field'>
            <Grid container spacing={1}>
              <Grid item xs={12} md={4}>
                <TextField
                  id="CountryName"
                  name="CountryName"
                  label={
                    <span>
                      Country <span style={{ color: 'red' }}>*</span>
                    </span>
                  }
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formData.CountryName}
                  onChange={handleInputChange}
                  disabled={isFormDisabled}
                  error={error.CountryName}
                  helperText={error.CountryName ? "" : ""}
                  inputRef={countryNameRef}
                  onKeyDown={handleKeyPress}
                />
              </Grid>

              <Grid item xs={12} md={2}>
                <TextField
                  id="CountryCode"
                  name="CountryCode"
                  label="Country Code"
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formData.CountryCode}
                  onChange={handleInputChange}
                  disabled={isFormDisabled}
                  error={error.CountryCode}
                  helperText={error.CountryCode ? "" : ""}
                  inputRef={countryCodeRef}
                  onKeyDown={handleKeyPress}
                />
              </Grid>
              <Grid item xs={12} md={4} style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <Box
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                  justifyContent="center"
                  border="1px solid #ccc"
                  borderRadius="5px"
                  width={40}
                  height={40}
                  overflow="hidden"
                  position="relative"
                  sx={{ cursor: "pointer" }}
                >
                  {selectedImage ? (
                    <img
                      src={selectedImage}
                      alt="Uploaded Logo"
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                      }}
                    />
                  ) : (
                    <Typography variant="body2" color="textSecondary">
                      Browse
                    </Typography>
                  )}
                  <input
                    id="upload-photo"
                    type="file"
                    accept="image/*"
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      opacity: 0,

                    }}
                    disabled={isFormDisabled}
                    onChange={handleFileChange}

                  />
                </Box>
                <Typography variant='h7'>Upload Flag</Typography>
              </Grid>
            </Grid>

            <Grid container spacing={1}>
              <Grid item xs={12} md={2} style={{ marginTop: '5px' }}>
                <TextField
                  id="MobDigit"
                  name="MobDigit"
                  label="Mobile Digit"
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formData.MobDigit}
                  onChange={handleInputChange}
                  disabled={isFormDisabled}
                  inputRef={MobDigitRef}
                  onKeyDown={handleKeyPress}
                />
              </Grid>
              <Grid item xs={12} md={2} style={{ marginTop: '5px' }}>
                <TextField
                  id="PinDigit"
                  name="PinDigit"
                  label="Pin Digit"
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formData.PinDigit}
                  onChange={handleInputChange}
                  disabled={isFormDisabled}
                  inputRef={PinDigitRef}
                  onKeyDown={handleKeyPress}
                />
              </Grid>
              <Grid item xs={12} md={2} style={{ marginTop: '5px' }}>
                <TextField
                  id="ShortName"
                  name="ShortName"
                  label="Short Name"
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formData.ShortName}
                  onChange={handleInputChange}
                  disabled={isFormDisabled}
                  inputRef={shortNameRef}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={3} >
                <FormGroup sx={{ marginTop: "10px" }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        disabled={isFormDisabled}
                        checked={Status === "1"}
                        onChange={handleChangeStatus}
                      />
                    }
                    label="Status"
                  />
                </FormGroup>
              </Grid>
            </Grid>
          </Grid>


          <Grid item xs={12} className="form_button">
            {mode === 'view' && (
              <>
                <Button variant="contained" sx={{ mr: 1, background: 'linear-gradient(290deg, #d4d4d4, #ffffff)' }} onClick={handleAdd} disabled>
                  Submit
                </Button>
                <Button variant="contained" sx={{ mr: 1, background: 'linear-gradient(290deg, #a7c5e9, #ffffff)' }} onClick={handleEdit}
                  disabled
                >
                  Cancel
                </Button>
              </>
            )}
            {(mode === 'edit' || mode === 'add') && (
              <>

                <Button variant="contained" sx={{ mr: 1 }} onClick={handleSave} >
                  Submit
                </Button>
                <Button variant="contained" sx={{ mr: 1 }} onClick={handleCancel}>
                  Cancel
                </Button>

              </>
            )}
          </Grid>
        </Grid>
      </Box>

      <div style={{ display: 'none' }}>
        {Object.keys(DataForPrint).length > 0 && <ReportTable
            columns={columns}
            rows={rows}
            title="Country Master"
            contentRef={contentRef}
            customStyles={{ backgroundColor: '#f5f5f5' }}
        />
        }
      </div>

      <Dialog
        open={openConfirmDialog}
        onClose={handleCloseConfirmDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Confirm Deletion"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this record?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{
              backgroundColor: '#635bff',
              color: 'white',
              '&:hover': {
                backgroundColor: '#1565c0',
                color: 'white'
              }
            }}
            onClick={handleConfirmDelete}
          >
            Yes
          </Button>
          <Button
            sx={{
              backgroundColor: '#635bff',
              color: 'white',
              '&:hover': {
                backgroundColor: '#1565c0',
                color: 'white'
              }
            }}
            onClick={handleCloseConfirmDialog}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default Country;